import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { SourceChannelState, SourceChannelStore } from './sourceChannel.store';

@Injectable({ providedIn: 'root' })
export class SourceChannelQuery extends QueryEntity<SourceChannelState> {
  constructor(protected override store: SourceChannelStore) {
    super(store);
  }

  getDataFormTicket() {
    return this.getValue().dataFormTicket;
  }

  searchSourceChannelByName(searchName: string = '') {
    return this.selectAll({
      filterBy: sources => sources.name?.toLocaleLowerCase().includes(searchName?.trim()?.toLocaleLowerCase())
    });
  }

  getSourceChannelByUuid(uuid: string) {
    return this.getEntity(uuid);
  }

  selectSourceChannelByUuid(uuid: string) {
    return this.selectEntity(uuid);
  }

  selectSourceMailboxByUuid(uuid: string) {
    return this.selectEntity(uuid, 'sourceMailbox');
  }
}
